"use client";
import Image from "next/image";
import { useState } from "react";
import img from "@/assets/Srsf4Xqkzlبارگیری-۳.jpeg";
import Navbar from "@/components/Navbar";
import Items from "@/components/Items";
import Footer from "@/components/Footer";
import classes from "./Product.module.css";
import { ShoppingCart } from "lucide-react";
import { Product } from "@/types/productsType";


//eslint-disable-next-line @typescript-eslint/no-unused-vars
const ProductCard = ({ product }: { product: Product }) => {
  const [count, setCount] = useState(0);
  return (
    <div className={classes.main}>
      <Navbar />
      <div className="flex items-center justify-center min-h-screen p-4 w-full h-full">
        <div className="flex flex-col md:flex-row rounded-xl p-6 space-x-4 w-full h-full">
          <div className="flex flex-col items-center w-full h-full">
            <Image
              src={img}
              alt="پودر ژله هندوانه فرمند"
              className="object-cover mt-2 w-full h-full"
            />
          </div>
          <div className="flex flex-col justify-center items-center text-right w-full h-full mb-5">
            <span className="bg-red-500 text-white  px-5 py-2 rounded-md w-fit h-10px mb-2 mt-4">
              25% تخفیف ویژه
            </span>
            <h1 className="text-xl font-bold text-gray-800  mt-2">
              ژل ماشین ظرفشویی
            </h1>
          </div>
          <div className="items-center space-x-2 bg-gray-100 p-3 rounded-lg w-full h-full">
            <div className="mt-5 w-full h-full mb-10 flex items-center justify-center gap-2">
              <span className="text-gray-400 line-through text-lg">
                ۳۰,۰۰۰ تومان
              </span>
              <span className="text-green-600 font-bold text-xl mr-2">
                ۲۲,۵۰۰ تومان
              </span>
            </div>
            <div>
              {count > 0 ? (
                <div className={classes.counterBox}>
                  <button
                    className={classes.addButton}
                    onClick={() => setCount(count + 1)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4.5v15m7.5-7.5h-15"
                      />
                    </svg>
                  </button>
                  <span className={classes.count}>{count}</span>
                  <button
                    className={classes.deleteButton}
                    onClick={() => setCount(count - 1)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      className="size-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 12h14"
                      />
                    </svg>
                  </button>
                </div>
              ) : (
                <button
                  className={classes.addToCart}
                  onClick={() => setCount(1)}
                >
                  <span className={classes.addToCartText}>
                    افزودن به سبد خرید
                  </span>
                  <ShoppingCart className={classes.addToCartIcon} />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <Items text="محصولات مشابه" link="" />
      <Footer />
    </div>
  );
};

export default ProductCard;
